module.exports = __webpack_public_path__ + "318bfb52339b09813e996c27f4df1234.png";